import { Button } from "@tremor/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { verifyEmail } from "../api/auth.js";
import { useAuthStore } from "../store/authStore.js";

import { useTranslation } from "react-i18next";

export default function VerifyEmail() {
  const { t } = useTranslation("auth");
  const navigate = useNavigate();
  const setSession = useAuthStore((s) => s.setSession);

  const [status, setStatus] = useState("verifying"); // "verifying" | "success" | "error"
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) {
      setStatus("error");
      setError(t("verify_email.error_token"));
      return;
    }

    verifyEmail(token)
      .then((data) => {
        setSession(data);
        setStatus("success");
        setTimeout(() => navigate("/dashboard", { replace: true }), 1500);
      })
      .catch((err) => {
        setStatus("error");
        setError(
          err.response?.data?.error ?? t("verify_email.error_invalid")
        );
      });
  }, [navigate, setSession, t]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="w-full max-w-sm rounded-lg bg-white p-8 shadow text-center">
        <h1 className="mb-2 text-2xl font-bold text-gray-900">Monitero</h1>

        {status === "verifying" && (
          <>
            <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-4 border-teal-600 border-t-transparent" />
            <p className="text-sm text-gray-500">{t("verify_email.verifying")}</p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
              <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-sm font-medium text-gray-800">{t("verify_email.success")}</p>
          </>
        )}

        {status === "error" && (
          <>
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
              <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <p className="mb-4 text-sm text-red-600">{error}</p>
            <Button variant="light" onClick={() => navigate("/login", { replace: true })}>
              {t("verify_email.back_to_login")}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
